import React, { createContext, useContext, useState, useCallback } from 'react';
import { Snackbar, Alert } from '@mui/material';

const AlertContext = createContext(null);

export const AlertProvider = ({ children }) => {
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState({
        severity: 'info',
        message: '',
        duration: 4000,
    });

    const notify = useCallback(
        ({ severity = 'info', message = '', duration = 4000 }) => {
            setOptions({ severity, message, duration });
            setOpen(true);
        },
        []
    );

    const handleClose = () => setOpen(false);

    return (
        <AlertContext.Provider value={{ notify }}>
            {children}

            <Snackbar
                open={open}
                autoHideDuration={options.duration}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                sx={{zIndex: 100000}}
            >
                <Alert
                    onClose={handleClose}
                    severity={options.severity}
                    variant="filled"
                    sx={{ width: '100%'}}
                >
                    {options.message}
                </Alert>
            </Snackbar>
        </AlertContext.Provider>
    );
};

export const useAlert = () => useContext(AlertContext);
